import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=fcfd415c&scoped=true&"
import script from "./AdminStatistics.vue?vue&type=script&lang=js&"
export * from "./AdminStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatistics.vue?vue&type=style&index=0&id=fcfd415c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfd415c",
  null
  
)

export default component.exports